export default {
  setBannersHome(state, banners) {
    state.bannersHome = banners || [];
  },
};
